//stage0Hover.js
export function mountStage0Hover({ root, isMobile = false } = {}) {
  const wrap = root?.querySelector('.story-image');
  if (!wrap) return { destroy() {} };

  const caption = wrap.querySelector('.story-hover');
  if (!caption) return { destroy() {} };

  function show() {
    wrap.classList.add('is-hover');
  }

  function hide() {
    wrap.classList.remove('is-hover');
  }

  let onEnter, onLeave, onClick;

  if (isMobile) {
    onClick = () => {
      wrap.classList.toggle('is-hover');
    };

    wrap.addEventListener('click', onClick);
  } else {
    onEnter = () => show();
    onLeave = () => hide();

    wrap.addEventListener('pointerenter', onEnter);
    wrap.addEventListener('pointerleave', onLeave);
  }

  return {
    destroy() {
      wrap.classList.remove('is-hover');

      if (onEnter) wrap.removeEventListener('pointerenter', onEnter);
      if (onLeave) wrap.removeEventListener('pointerleave', onLeave);
      if (onClick) wrap.removeEventListener('click', onClick);
    },
  };
}
